import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { StorageItems } from '../constants/storage-items.constants';
import { collection, FBaseService } from '../services/firebase/f-base.service';

export const PublicGuard = async (data: any) => {
  const authService = inject(AuthService);
  const fbService = inject(FBaseService);
  const router = inject(Router);

  let user: any;
  try {
    user = await firstValueFrom(authService.currentUserObservable());

    if (user && user.uid) {
      const appUser = await firstValueFrom(fbService.getById(collection.users, user.uid)) as any;
      if (!appUser) {
        await authService.fbLogout();
        localStorage.removeItem(StorageItems.USERID);
        return true;
      }

      localStorage.setItem(StorageItems.USERID, user.uid);
      return router.parseUrl(appUser.privacyPolicyAccepted ? 'home' : 'privacy-policy');
    }
  } catch (error) {
    console.error('Authentication error:', error);
  }
  return true;
};
